/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type FotoEventoTipo = 'URL' | 'DB' | 'AWS';

export const FotoEventoTipo = {
    URL: 'URL' as FotoEventoTipo,
    DB: 'DB' as FotoEventoTipo,
    AWS: 'AWS' as FotoEventoTipo
};

